(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  const sliders = document.querySelectorAll(".slider-product");

  sliders.forEach(function (slider) {

    const wrapper = slider.querySelector(".slides-wrapper");
    const slides = slider.querySelectorAll(".slide-item");
    const total = slides.length;

    if (total <= 1) return;

    let index = 0;
    let startX = 0;
    let currentTranslate = 0;
    let isDragging = false;
    let autoSlide;

    function updateSlide() {
      wrapper.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
    }

    function startAutoSlide() {
      autoSlide = setInterval(function () {
        index = (index + 1) % total;
        updateSlide();
      }, 4000);
    }

    function stopAutoSlide() {
      clearInterval(autoSlide);
    }

    // 👉 Auto start
    startAutoSlide();

    // 👉 Touch Events (Mobile Swipe)
    slider.addEventListener("touchstart", function (e) {
      stopAutoSlide();
      isDragging = true;
      startX = e.touches[0].clientX;
    });

    slider.addEventListener("touchmove", function (e) {
      if (!isDragging) return;
      const currentX = e.touches[0].clientX;
      const diff = currentX - startX;
      currentTranslate = (-index * slider.offsetWidth) + diff;
      wrapper.style.transform = `translate3d(${currentTranslate}px,0,0)`;
    });

    slider.addEventListener("touchend", function (e) {
      isDragging = false;
      const endX = e.changedTouches[0].clientX;
      const diff = endX - startX;

      if (diff > 50 && index > 0) {
        index--;
      } else if (diff < -50 && index < total - 1) {
        index++;
      }

      updateSlide();
      startAutoSlide();
    });

    // 👉 Mouse Drag (Desktop)
    slider.addEventListener("mousedown", function (e) {
      stopAutoSlide();
      isDragging = true;
      startX = e.clientX;
      slider.style.cursor = "grabbing";
    });

    slider.addEventListener("mousemove", function (e) {
      if (!isDragging) return;
      const diff = e.clientX - startX;
      currentTranslate = (-index * slider.offsetWidth) + diff;
      wrapper.style.transform = `translate3d(${currentTranslate}px,0,0)`;
    });

    slider.addEventListener("mouseup", function (e) {
      if (!isDragging) return;
      isDragging = false;
      slider.style.cursor = "grab";
      const diff = e.clientX - startX;

      if (diff > 50 && index > 0) {
        index--;
      } else if (diff < -50 && index < total - 1) {
        index++;
      }

      updateSlide();
      startAutoSlide();
    });

    slider.addEventListener("mouseleave", function () {
      if (isDragging) {
        isDragging = false;
        updateSlide();
        startAutoSlide();
      }
    });

  });

});

  } catch(e) { console.error(e); }
})();
})();
